// src/components/SellProfile/MyProject.js
import React, { useState, useEffect } from "react";
import { CiSearch } from "react-icons/ci";
import { FaAngleRight, FaChevronLeft } from "react-icons/fa";
import { TbArrowsSort, TbDotsCircleHorizontal } from "react-icons/tb";
import { Button, Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import logo from "../../assets/logo/Logo.png";
import { IoMdCloseCircle } from "react-icons/io";
import { useForm } from "react-hook-form";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { FaTimes } from "react-icons/fa";
import rocketWhite from "../../assets/images/icons/rocket-white.svg";
import rocketGreen from "../../assets/images/icons/rocket-green.svg";
import PromoteListingModal from "../PromoteListing/PromoteListingModal";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const MyProject = ({ sellerId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const [productsError, setProductsError] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(null); // product.id for dropdown
  const [editingProduct, setEditingProduct] = useState(null); // product object being edited
  const [searchQuery, setSearchQuery] = useState("");
const [sellerIdState, setSellerIdState] = useState(() => {
    return sellerId ?? (Number(sessionStorage.getItem("sellerId")) || null);
  });
const [viewingProduct, setViewingProduct] = useState(null);
const [promotingProduct, setPromotingProduct] = useState(null); // product being promoted

  useEffect(() => {
    if (sellerId) {
      setSellerIdState(sellerId);
      try {
        sessionStorage.setItem("sellerId", String(sellerId));
        localStorage.setItem("sellerId", String(sellerId));
      } catch (e) {
        console.warn("Unable to persist sellerId to sessionStorage", e);
      }
    }
  }, [sellerId]);
 
 
  // Fetch products (with optional search). Uses API: /api/product/get-products
// ...existing code...
  // Fetch products (with optional search). Uses API: /api/product/get-products
  const fetchProducts = async (search = "") => {
    setProductsLoading(true);
    setProductsError(null);
    try {
      // build filters: include search (if any) and seller_id when available
      const filters = { ...(search ? { search } : {}) };
      if (sellerIdState) filters.seller_id = Number(sellerIdState);

      const res = await axios.post(
        `${API_BASE_URL}/product/get-products`,
        {
          filters,
          page: 1,
          limit: 1000, // fetch many and handle pagination client-side (adjust as needed)
        },
        {
          headers: {
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.success) {
        setProducts(res.data.result.products || []);
      } else {
        setProducts([]);
        setProductsError("Unable to load products. Please try again.");
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      setProducts([]);
      setProductsError("Unable to load products. Please try again.");
    } finally {
      setProductsLoading(false);
    }
  };
// ...existing code...

  // Initial load + reload on search change
  useEffect(() => {
    fetchProducts(searchQuery);
  }, [searchQuery, sellerIdState]);

  const totalPages = Math.max(1, Math.ceil(products.length / itemsPerPage));
  const paginatedProducts = products.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // Delete product via edit-product endpoint with is_deleted true
  const handleDeleteProduct = async (productId) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;

    try {
      const payload = {
        product_id: productId,
        is_deleted: true,
      };

      const res = await axios.post(
        `${API_BASE_URL}/product/edit-product`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
        }
      );

      if (res.data.success) {
        alert("🗑️ Product deleted successfully");
        setProducts((prev) => prev.filter((p) => p.id !== productId));
      } else {
        alert(res.data.message || "Failed to delete product");
      }
    } catch (err) {
      console.error("Error deleting product:", err);
      alert("An error occurred while deleting the product");
    }
  };

  return (
    <div>
      <div className="p-2">
        <div className="flex items-center gap-1 w-[500px] border border-green-700 mt-8 flex-grow bg-[#F0F0F0] rounded-2xl px-2 py-3 shadow-inner">
          <CiSearch className="text-3xl  text-gray-400" />

          <input
            type="text"
            placeholder="Search Products"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
            className="flex-grow outline-none  bg-transparent text-lg text-gray-700"
          />
        </div>

        <div>
          <div className="p-6 mt-5 bg-white rounded-xl shadow-md border-2">
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-xl font-semibold">Products</h2>
              <div className="flex items-center gap-3">
                {/* Pass fetchProducts so modal can refresh list after add */}
                <MyModal setProducts={setProducts} fetchProducts={fetchProducts} />
              </div>
            </div>

            <div>
              <table className="min-w-full table-auto border rounded-lg">
                <thead className="bg-gray-100 text-gray-700 text-sm font-semibold">
                  <tr>
                    <th className="px-4 py-3 text-left">
                      <TbArrowsSort />
                    </th>
                    <th className="px-4 py-3 text-left">Name</th>
                    <th className="px-4 py-3 text-left">Price</th>
                    <th className="px-4 py-3 text-left">Stock Quantity</th>
                    <th className="px-4 py-3 text-left">Categories</th>
                    <th className="px-4 py-3 text-left">Offer</th>
                    <th className="px-4 py-3 text-left">Status</th>
                    <th className="px-4 py-3 text-left">Action</th>
                  </tr>
                </thead>

                <tbody className="text-sm text-gray-800">
                  {(productsLoading || productsError || products.length === 0) && (
                    <tr>
                      <td colSpan={8} className="px-4 py-10 text-center text-gray-500" role="status">
                        {productsLoading ? "Loading..." : productsError || (searchQuery ? "No products found" : "No products added")}
                      </td>
                    </tr>
                  )}
                  {!productsLoading && !productsError && paginatedProducts.map((product) => (
                    <tr key={product.id} className="border-b hover:bg-gray-50 transition-colors">
                      <td className="px-4 py-3 gap-3">
                        <img
                          src={product?.product_media?.[0]?.url || "/image/default.png"}
                          alt={product.product_name}
                          className="w-10 h-10 object-cover rounded"
                        />
                      </td>
<td
  className="px-4 py-3 text-green-700 underline cursor-pointer"
  onClick={() => setViewingProduct(product)}
>
  {product.product_name}
</td>
                      <td className="px-4 py-3">₹{product.product_price}</td>
                      <td className="px-4 py-3">{product.product_qty}</td>
                      <td className="px-4 py-3">
                        {product.category?.title || "N/A"}
                        {product.subcategory ? `, ${product.subcategory.title}` : ""}
                      </td>
                      <td className="px-4 py-3">
                        <span className="px-2 py-1 text-xs border-2 border-green-500 text-green-500 rounded-full">
                          {product.offer_percentage ? `${product.offer_percentage}%` : "0%"}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <span
                          className={`px-2 py-1 text-xs rounded-full text-white ${
                            product.product_qty > 0 ? "bg-[#39B54A]" : "bg-[#BE1F2E]"
                          }`}
                        >
                          {product.product_qty > 0 ? "In Stock" : "Out of Stock"}
                        </span>
                      </td>

                      <td className="px-4 py-3 relative">
                        <button
                          className="text-black"
                          onClick={() =>
                            setDropdownOpen(dropdownOpen === product.id ? null : product.id)
                          }
                        >
                          <TbDotsCircleHorizontal className="text-3xl" />
                        </button>

                        {dropdownOpen === product.id && (
                          <div className="absolute right-0 mt-2 w-32 bg-white border rounded-md shadow-lg z-10">
                            <button
                              onClick={() => {
                                setEditingProduct(product);
                                setDropdownOpen(null);
                              }}
                              className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => {
                                setPromotingProduct(product);
                                setDropdownOpen(null);
                              }}
                              className="flex items-center gap-1.5 w-full text-left px-4 py-2 text-sm text-green-700 hover:bg-gray-100"
                            >
                              <img src={rocketGreen} alt="" className="w-4 h-4" />
                              Promote
                            </button>
                            <button
                              onClick={() => {
                                handleDeleteProduct(product.id);
                                setDropdownOpen(null);
                              }}
                              className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                            >
                              Delete
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Edit modal (rendered when editingProduct set) */}
              {editingProduct && (
                <EditProductModal
                  product={editingProduct}
                  setProducts={setProducts}
                  onClose={() => setEditingProduct(null)}
                  refresh={() => fetchProducts(searchQuery)}
                />
              )}
              {viewingProduct && (
  <ViewProductModal
    product={viewingProduct}
    onClose={() => setViewingProduct(null)}
    onEdit={() => {
      setEditingProduct(viewingProduct);
      setViewingProduct(null);
    }}
    onPromote={() => {
      setPromotingProduct(viewingProduct);
      setViewingProduct(null);
    }}
  />
)}
{promotingProduct && (
  <PromoteListingModal
    product={promotingProduct}
    onClose={() => setPromotingProduct(null)}
  />
)}

            </div>

            <div className="flex justify-end items-center gap-2 mt-4">
              <button
                className="p-2 border rounded hover:bg-gray-100"
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <FaChevronLeft />
              </button>

              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  onClick={() => goToPage(i + 1)}
                  className={`px-3 py-1 border text-black rounded ${
                    currentPage === i + 1 ? "bg-[#F6F6F6]" : "hover:bg-gray-100"
                  }`}
                >
                  {i + 1}
                </button>
              ))}

              <button
                className="p-2  border rounded hover:bg-gray-100"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <FaAngleRight />
              </button>
            </div>
          </div>

          <div></div>
        </div>
      </div>
    </div>
  );
};

export default MyProject;

/* ---------------- EditProductModal (in-file component) ----------------- */
const EditProductModal = ({ product, setProducts, onClose, refresh }) => {
  const { register, handleSubmit, reset, watch, setValue } = useForm();
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [error, setError] = useState(null);
  const productPrice = watch("product_price");
  const offerPercentage = watch("offer_percentage");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch categories & subcategories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/product_category/get-categories`,
          { filters: {}, page: 1, limit: 100 },
          { headers: { token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") } }
        );
        if (res.data.success) setCategories(res.data.result.ProductCategories || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    const fetchSubCategories = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/product_subcategory/get-categories`,
          { filters: {}, page: 1, limit: 100 },
          { headers: { token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") } }
        );
        if (res.data.success) setSubCategories(res.data.result.ProductSubcategories || []);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };

    fetchCategories();
    fetchSubCategories();
  }, []);

  // Prefill form and preload existing media URLs as completed entries
  useEffect(() => {
    if (!product) return;
    reset({
      product_name: product.product_name,
      brand_name: product.brand_name,
      description: product.description,
      product_price: product.product_price,
      discount_price: product.discount_price,
      offer_percentage: product.offer_percentage,
      product_qty: product.product_qty,
      category_id: product.category_id,
      sub_category_id: product.sub_category_id,
    });

   setUploadedMedia(
  (product.product_media || [])
    .filter((m) => {
      const url = m.url?.toLowerCase() || "";
      return (
        m.media_type === "image" ||
        m.type === "image" ||
        url.endsWith(".jpg") ||
        url.endsWith(".jpeg") ||
        url.endsWith(".png") ||
        url.endsWith(".webp")
      );
    })
    .map((m) => ({
      id: uuidv4(),
      file: null,
      url: m.url,
      media_type: "image", // force only images
      type: "image",
      status: "Completed",
      progress: 100,
    }))
);

  }, [product, reset, categories, subCategories]);

  // Auto-calc discount price when price or offer change
  useEffect(() => {
    if (productPrice !== undefined && offerPercentage !== undefined) {
      const p = parseFloat(productPrice || 0);
      const o = parseFloat(offerPercentage || 0);
      if (p >= 0 && !isNaN(o)) {
        const discount = p * (1 - o / 100);
        setValue("discount_price", discount.toFixed(2));
      }
    }
  }, [productPrice, offerPercentage, setValue]);

  // Handle local media selection (images & mp4)
  // const handleLocalMedia = (e) => {
  //   setError(null);
  //   const files = Array.from(e.target.files || []);
  //   const processed = [];

  //   for (const file of files) {
  //     const isImage = file.type.startsWith("image/");
  //     const isVideo = file.type === "video/mp4";

  //     if (isImage) {
  //       if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
  //         setError("Only JPG, PNG, WEBP images are allowed.");
  //         continue;
  //       }
  //       if (file.size > 10 * 1024 * 1024) {
  //         setError("Image size must not exceed 10MB.");
  //         continue;
  //       }
  //     } else if (isVideo) {
  //       if (file.size > 50 * 1024 * 1024) {
  //         setError("Video size must not exceed 50MB.");
  //         continue;
  //       }
  //     } else {
  //       setError("Unsupported file type. Only images (JPG/PNG/WEBP) or MP4 allowed.");
  //       continue;
  //     }

  //     processed.push({
  //       id: uuidv4(),
  //       file,
  //       url: URL.createObjectURL(file),
  //       media_type: isImage ? "image" : "video",
  //        type: isImage ? "image" : "video",
  //       status: "Ready",
  //       progress: 0,
  //     });
  //   }

  //   setUploadedMedia((prev) => [...prev, ...processed]);
  // };


  // Handle local media selection (images only — videos blocked)
  const handleLocalMedia = (e) => {
    setError(null);
    const files = Array.from(e.target.files || []);
    const processed = [];

    for (const file of files) {
      const isImage = file.type.startsWith("image/");

      if (!isImage) {
        setError("Only image files (JPG, PNG, WEBP) are allowed. Videos are not permitted.");
        continue;
      }

      if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
        setError("Only JPG, PNG, WEBP images are allowed.");
        continue;
      }

      if (file.size > 10 * 1024 * 1024) {
        setError("Image size must not exceed 10MB.");
        continue;
      }

      processed.push({
        id: uuidv4(),
        file,
        url: URL.createObjectURL(file),
        media_type: "image",
        type: "image",
        status: "Ready",
        progress: 0,
      });
    }

    if (processed.length > 0) {
      setUploadedMedia((prev) => [...prev, ...processed]);
    }

    // reset input so same file can be reselected later
    if (e.target) e.target.value = "";
  };

  // Upload only new files (those with .file) and update uploadedMedia URLs
  const uploadFiles = async () => {
    const newFiles = uploadedMedia.filter((m) => m.file);
    if (newFiles.length === 0) {
      // return existing media as-is
      return uploadedMedia.map((m) => ({ url: m.url, media_type: m.media_type }));
    }

    const fileData = newFiles.map((m) => ({ fileName: m.file.name, fileType: m.file.type }));
    try {
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: fileData },
        { headers: { token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") } }
      );

      if (!response.data.success) throw new Error(response.data.message || "Presigned error");

      const preSignedUrls = response.data.directory;

      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          const mediaItem = newFiles[index];
          const config = {
            headers: { "Content-Type": mediaItem.file.type },
            onUploadProgress: (e) => {
              const percent = Math.round((e.loaded * 100) / e.total);
              setUploadedMedia((prev) =>
                prev.map((m) =>
                  m.id === mediaItem.id ? { ...m, progress: percent, status: "Uploading" } : m
                )
              );
            },
          };

          await axios.put(item.presignedUrl, mediaItem.file, config);

          const kind = mediaItem.file.type.startsWith("image") ? "image" : "video";
         setUploadedMedia((prev) =>
           prev.map((m) =>
             m.id === mediaItem.id
               ? { ...m, status: "Completed", progress: 100, url: item.fileUrl, type: kind, media_type: kind }
               : m
            )
        );
        })
      );

      // Return full media array (existing + newly uploaded with updated urls)
      return uploadedMedia.map((m) => ({ url: m.url, media_type: m.media_type }));
    } catch (err) {
      console.error("Upload error:", err);
      setError("Failed to upload files. Please try again.");
      throw err;
    }
  };

  // Submit edited product
  const onSubmit = async (data) => {
    // Basic validations:
    setError(null);
    // Ensure product name valid
    if (!data.product_name || data.product_name.trim().length < 3) {
      setError("Title is required (min 3 chars).");
      return;
    }
    const priceNum = parseFloat(data.product_price);
    if (isNaN(priceNum) || priceNum <= 0) {
      setError("Price must be greater than 0.");
      return;
    }
    const qtyNum = parseInt(data.product_qty, 10);
    if (isNaN(qtyNum) || qtyNum < 0) {
      setError("Stock quantity must be 0 or more.");
      return;
    }
    if (data.discount_price && parseFloat(data.discount_price) > priceNum) {
      setError("Discount cannot exceed base price.");
      return;
    }

    // At least one image must exist either already or in uploadedMedia (file or existing)
    // const hasImage =
    //   (uploadedMedia && uploadedMedia.some((m) => m.media_type === "image")) ||
    //   (product.product_media && product.product_media.length && product.product_media.some((m) => m.media_type === "image"));

    // if (!hasImage) {
    //   setError("At least one image is required.");
    //   return;
    // }

    setLoading(true);
    try {
      const productMedia = await uploadFiles();

      // ensure returned productMedia contains at least one image
      if (!productMedia.some((m) => m.media_type === "image")) {
        // setError("At least one image is required.");
        setLoading(false);
        return;
      }

      const payload = {
        product_id: product.id,
        product_name: data.product_name,
        brand_name: data.brand_name,
        description: data.description,
        category_id: Number(data.category_id),
        sub_category_id: Number(data.sub_category_id),
        product_price: parseFloat(data.product_price),
        discount_price: parseFloat(data.discount_price || 0),
        offer_percentage: parseFloat(data.offer_percentage || 0),
        product_qty: parseInt(data.product_qty),
        is_deleted: false,
        product_media: productMedia,
        inStock: parseInt(data.product_qty) > 0,
      };

      const res = await axios.post(
        `${API_BASE_URL}/product/edit-product`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
        }
      );

      if (res.data.success) {
        alert("✅ Product updated successfully");
        // refresh list by calling parent refresh if provided
        if (refresh) refresh();
        // Update local list as fallback
        setProducts((prev) => prev.map((p) => (p.id === product.id ? { ...p, ...payload } : p)));
        onClose();
      } else {
        setError(res.data.message || "Failed to update product");
      }
    } catch (err) {
      console.error("Error editing product:", err);
      setError("Something went wrong while updating product.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-[95%] md:w-[700px] max-h-[90vh] overflow-y-auto relative">
        <button className="absolute top-2 right-2 text-gray-500" onClick={onClose}>
          ✕
        </button>
        <div>
          <img src={logo} alt="Pipaan Logo" width={120} height={10} />
        </div>
        <h2 className="text-xl font-semibold mb-4">Edit Product</h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Product Name</label>
            <input {...register("product_name", { required: true, minLength: 3 })} className="w-full border rounded p-2" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Brand Name</label>
            <input {...register("brand_name", { required: true })} className="w-full border rounded p-2" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Description</label>
            <textarea {...register("description")} className="w-full border rounded p-2" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Category</label>
            <select {...register("category_id", { required: true })} className="w-full border rounded p-2" defaultValue={product.category_id}>
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.title}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Sub Category</label>
            <select {...register("sub_category_id", { required: true })} className="w-full border rounded p-2" defaultValue={product.sub_category_id}>
              <option value="">Select Sub Category</option>
              {subCategories.map((sub) => (
                <option key={sub.id} value={sub.id}>
                  {sub.title}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Price</label>
            <input type="number" step="0.01" {...register("product_price", { required: true, min: 0.01 })} className="w-full border rounded p-2" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Discount Price</label>
            <input type="number" step="0.01" readOnly {...register("discount_price")} className="w-full border rounded p-2 bg-gray-50" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Offer Percentage</label>
            <input type="number" step="0.01" {...register("offer_percentage")} className="w-full border rounded p-2" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Stock Quantity</label>
            <input type="number" {...register("product_qty", { required: true, min: 0 })} className="w-full border rounded p-2" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Product Media </label>
            {/* <input type="file" multiple accept="image/jpeg,image/png,image/webp,video/mp4" onChange={handleLocalMedia} className="mb-2" /> */}
                    <input type="file" multiple accept="image/jpeg,image/png,image/webp" onChange={handleLocalMedia} className="mb-2" />

            <div className="flex gap-2 flex-wrap">
              {uploadedMedia.map((media, index) => (
                <div key={media.id || index} className="relative">
                  {media.type === "image" ? (
                    <img src={media.url} className="rounded-lg max-w-[150px] max-h-[150px]" alt="preview" />
                  ) : (
                    <video src={media.url} controls className="rounded-lg max-w-[150px] max-h-[150px]" />
                  )}
                  <div className="absolute bottom-2 left-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded">
                    {media.status} - {media.progress}%
                  </div>
                  <button
                    onClick={() => {
                      setUploadedMedia((prev) => prev.filter((_, i) => i !== index));
                      URL.revokeObjectURL(media.url);
                    }}
                    type="button"
                    className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1"
                  >
                    <FaTimes />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {error && <p className="text-red-500">{error}</p>}

          <div>
            <button disabled={loading} className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700">
              {loading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
/* ---------------- ViewProductModal (read-only popup) ----------------- */
const ViewProductModal = ({ product, onClose, onEdit, onPromote }) => {
  if (!product) return null;

  const media = product.product_media || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-[95%] md:w-[700px] max-h-[90vh] overflow-y-auto relative">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
          onClick={onClose}
        >
          ✕
        </button>

        <h2 className="text-2xl font-semibold mb-4 text-center">
          Product Details
        </h2>

        {/* Media section */}
        {media.length > 0 ? (
          <div className="flex flex-wrap justify-center gap-3 mb-4">
            {media
              .filter(
                (m) =>
                  m.media_type === "image" ||
                  m.type === "image" ||
                  /\.(jpg|jpeg|png|webp)$/i.test(m.url)
              )
              .map((m, i) => (
                <img
                  key={i}
                  src={m.url}
                  alt="Product media"
                  className="w-[150px] h-[150px] object-cover rounded-lg border"
                />
              ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center mb-4">
            No media available.
          </p>
        )}

        {/* Product details */}
        <div className="space-y-2 text-gray-700 text-sm">
          <p><strong>Name:</strong> {product.product_name}</p>
          <p><strong>Brand:</strong> {product.brand_name || "N/A"}</p>
          <p><strong>Description:</strong> {product.description || "N/A"}</p>
          <p><strong>Category:</strong> {product.category?.title || "N/A"}</p>
          <p><strong>Subcategory:</strong> {product.subcategory?.title || "N/A"}</p>
          <p><strong>Price:</strong> ₹{product.product_price}</p>
          <p><strong>Discount Price:</strong> ₹{product.discount_price}</p>
          <p><strong>Offer:</strong> {product.offer_percentage || 0}%</p>
          <p><strong>Quantity:</strong> {product.product_qty}</p>
          <p>
            <strong>Status:</strong>{" "}
            {product.product_qty > 0 ? (
              <span className="text-green-600">In Stock</span>
            ) : (
              <span className="text-red-600">Out of Stock</span>
            )}
          </p>
        </div>

        <div className="mt-6 flex justify-center gap-3">
          <button
            onClick={onEdit}
            className="bg-[#095228] hover:bg-[#06381c] text-white px-6 py-2 rounded-full font-semibold"
          >
            Edit
          </button>
          <button
            onClick={onPromote}
            className="flex items-center gap-2 bg-gradient-to-r from-[#3CB44B] to-[#8A8A3C] hover:opacity-90 text-white px-6 py-2 rounded-full font-semibold"
          >
            <img src={rocketWhite} alt="" className="w-5 h-5" />
            Promote
          </button>
        </div>
      </div>
    </div>
  );
};

/* ---------------- MyModal (Add Product) ----------------- */
function MyModal({ setProducts, fetchProducts }) {
  const { register, handleSubmit, watch, setValue, formState: { errors }, reset } = useForm();
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [error, setError] = useState(null);
  let [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const productPrice = watch("productPrice");
  const offerPercentage = watch("offerPercentage");

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    // Auto-calc discount
    if (productPrice !== undefined && offerPercentage !== undefined) {
      const p = parseFloat(productPrice || 0);
      const o = parseFloat(offerPercentage || 0);
      if (!isNaN(p) && !isNaN(o)) {
        const discount = p * (1 - o / 100);
        setValue("discountPrice", discount.toFixed(2));
      }
    }
  }, [productPrice, offerPercentage, setValue]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/product_category/get-categories`,
          { filters: {}, page: 1, limit: 100 },
          { headers: { token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") } }
        );
        if (res.data.success) setCategories(res.data.result.ProductCategories || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    const fetchSubCategories = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/product_subcategory/get-categories`,
          { filters: {}, page: 1, limit: 100 },
          { headers: { token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") } }
        );
        if (res.data.success) setSubCategories(res.data.result.ProductSubcategories || []);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };

    fetchCategories();
    fetchSubCategories();
  }, []);

  // Local media selection (images & MP4)
  // const handleMediaChange = (event) => {
  //   setError(null);
  //   const files = Array.from(event.target.files || []);
  //   const processed = [];

  //   for (const file of files) {
  //     const isImage = file.type.startsWith("image/");
  //     // const isVideo = file.type === "video/mp4";

  //     if (isImage) {
  //       if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
  //         setError("❌ Only JPG, PNG, WEBP images are allowed.");
  //         continue;
  //       }
  //       if (file.size > 10 * 1024 * 1024) {
  //         setError("❌ Image size must not exceed 10MB.");
  //         continue;
  //       }
  //     } else if (isVideo) {
  //       if (file.size > 50 * 1024 * 1024) {
  //         setError("❌ Video size must not exceed 50MB.");
  //         continue;
  //       }
  //     } else {
  //       setError("Unsupported file type. Only images (JPG/PNG/WEBP) or MP4 allowed.");
  //       continue;
  //     }

  //     processed.push({
  //       id: uuidv4(),
  //       file,
  //       url: URL.createObjectURL(file),
  //       media_type: isImage ? "image" : "video",
  //              type: isImage ? "image" : "video",

  //       status: "Ready",
  //       progress: 0,
  //     });
  //   }

  //   setUploadedMedia((prev) => [...prev, ...processed]);
  // };


   // Local media selection (images only — videos blocked)
  const handleMediaChange = (event) => {
    setError(null);
    const files = Array.from(event.target.files || []);
    const processed = [];

    for (const file of files) {
      const isImage = file.type.startsWith("image/");

      if (!isImage) {
        setError("Only image files (JPG, PNG, WEBP) are allowed. Videos are not permitted.");
        continue;
      }

      if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
        setError("Only JPG, PNG, WEBP images are allowed.");
        continue;
      }

      if (file.size > 10 * 1024 * 1024) {
        setError("Image size must not exceed 10MB.");
        continue;
      }

      processed.push({
        id: uuidv4(),
        file,
        url: URL.createObjectURL(file),
        media_type: "image",
        type: "image",
        status: "Ready",
        progress: 0,
      });
    }
 if (processed.length > 0) setUploadedMedia((prev) => [...prev, ...processed]);

    // reset input so same file can be selected again
    if (event.target) event.target.value = "";
  };
  // Upload files using your presigned URL approach (same as before)
  const uploadFiles = async () => {
    if (uploadedMedia.length === 0) return [];

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type,
    }));

    try {
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: fileData },
        { headers: { token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") } }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || "Failed to generate pre-signed URLs");
      }

      const preSignedUrls = response.data.directory;

      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          const mediaItem = uploadedMedia[index];
          const config = {
            headers: { "Content-Type": mediaItem.file.type },
            onUploadProgress: (e) => {
              const percent = Math.round((e.loaded * 100) / e.total);
              setUploadedMedia((prev) =>
                prev.map((m, i) => (i === index ? { ...m, progress: percent, status: "Uploading" } : m))
              );
            },
          };

          await axios.put(item.presignedUrl, mediaItem.file, config);

          const kind = mediaItem.file.type.startsWith("image") ? "image" : "video";
         setUploadedMedia((prev) =>
            prev.map((m, i) => (i === index ? { ...m, status: "Completed", progress: 100, url: item.fileUrl, type: kind, media_type: kind } : m))
         );
        })
      );

      return preSignedUrls.map((item) => ({
        url: item.fileUrl,
        media_type: item.fileType.startsWith("image") ? "image" : "video",
      }));
    } catch (error) {
      console.error("Upload error:", error);
      setError("Failed to upload files. Please try again.");
      return [];
    }
  };

  async function open() {
    if (loading) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/seller/get-seller-profile`, {}, {
        headers: { token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") },
      });
      if (!res.data.success || !res.data.result?.id) {
        alert("Please create a seller profile before adding products.");
        return;
      }
      setIsOpen(true);
    } catch (err) {
      alert(err.response?.status === 409
        ? "Please create a seller profile before adding products."
        : "Unable to verify your seller profile. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  function close() {
    setIsOpen(false);
    reset();
    setUploadedMedia([]);
    setError(null);
  }

  // Add product submit
  const onSubmit = async (data) => {
    setError(null);

    // validations
    if (!data.productname || data.productname.trim().length < 3) {
      setError("Title is required (min 3 chars).");
      return;
    }
    const priceNum = parseFloat(data.productPrice);
    if (isNaN(priceNum) || priceNum <= 0) {
      setError("Price must be greater than 0.");
      return;
    }
    const qtyNum = parseInt(data.productQty, 10);
    if (isNaN(qtyNum) || qtyNum < 0) {
      setError("Stock quantity must be 0 or more.");
      return;
    }
    if (data.discountPrice && parseFloat(data.discountPrice) > priceNum) {
      setError("Discount cannot exceed base price.");
      return;
    }

    // Require at least one image BEFORE proceeding
    // if (!uploadedMedia || uploadedMedia.length === 0) {
    //   setError("Please upload at least one image (MP4 video optional).");
    //   return;
    // }
    // if (!uploadedMedia.some((m) => m.media_type === "image")) {
    //   setError("At least one image is required.");
    //   return;
    // }

    setLoading(true);
    try {
      const productMedia = await uploadFiles();

      // ensure uploaded productMedia contains at least one image
      // if (!productMedia.some((m) => m.media_type === "image")) {
      //   setError("At least one image is required.");
      //   setLoading(false);
      //   return;
      // }
console.log("productMedia", productMedia);
      const payload = {
        product_name: data.productname,
        brand_name: data.brandname,
        description: data.productDescription,
        // product_type: null,
        category_id: Number(data.category_id),
        sub_category_id: Number(data.sub_category_id),
        product_price: parseFloat(data.productPrice),
        discount_price: parseFloat(data.discountPrice || 0),
        offer_percentage: parseFloat(data.offerPercentage || 0),
        product_qty: parseInt(data.productQty),
        product_media: productMedia,
      };

      const res = await axios.post(`${API_BASE_URL}/product/add-product`, payload, {
        headers: {
          token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      });

      if (res.data.success) {
        alert("✅ Product added successfully!");
        // refresh parent list
        if (fetchProducts) fetchProducts();
        close();
      } else {
        setError(res.data.message || "Failed to add product");
      }
    } catch (err) {
      console.error("Error adding product:", err);
      setError(err.response?.data?.message || "An error occurred while adding the product");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button onClick={open} disabled={loading} className="bg-[#095228] text-white px-4 py-2 rounded-3xl">
        Add Product
      </Button>

      <Dialog open={isOpen} as="div" className="relative z-50" onClose={close}>
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" aria-hidden="true" />
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <DialogPanel className="w-full max-w-3xl scroll-auto border-2 rounded-xl bg-white p-6 shadow-xl transition-all">
            <DialogTitle as="h3" className="text-lg font-medium text-gray-900">
              <div className="flex justify-between items-center">
                <div>
                  <img src={logo} alt="Pipaan Logo" width={120} height={10} />
                </div>
                <button onClick={close}>
                  <IoMdCloseCircle className="text-3xl text-[#095228]" />
                </button>
              </div>
            </DialogTitle>

            <div className="mt-5">
              <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 ">
                  <div className="w-full sm:w-1/2">
                    <label className="block font-medium mb-1 text-[14px]">Product Name</label>
                    <input
                      type="text"
                      {...register("productname", { required: true, minLength: { value: 3, message: "Minimum 3 characters required" } })}
                      placeholder="Enter product Name"
                      className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
                    />
                    {errors.productname && <p className="text-red-500">{errors.productname.message}</p>}
                  </div>

                  <div className="w-full sm:w-1/2">
                    <label className="block font-medium mb-1 text-[14px]">Brand Name</label>
                    <input type="text" {...register("brandname", { required: true })} placeholder="Enter Brand Name" className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700" />
                    {errors.brandname && <p className="text-sm text-red-500">Brand name is required</p>}
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-start gap-4">
                  <div className="w-full sm:w-1/2">
                    <label className="block font-medium mb-1 text-[14px]">Product Description</label>
                    <textarea {...register("productDescription", { required: true })} placeholder="Enter product description" className="w-full border rounded-md p-3 outline-none resize-none h-24" />
                    {errors.productDescription && <p className="text-sm text-red-500">Product description is required</p>}
                  </div>

                  <div className="w-full sm:w-1/2">
                    <label className="block font-medium mb-1 text-[14px]">Product Type</label>
                    <select {...register("category_id", { required: true })} className="w-full border text-[14px] rounded-md p-3 outline-none text-gray-700" defaultValue="">
                      <option value="" className="text-[#ccc]" disabled>Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.title}
                        </option>
                      ))}
                    </select>

                    <select {...register("sub_category_id", { required: true })} className="w-full border text-[14px] rounded-md p-3 outline-none text-gray-700 mt-2" defaultValue="">
                      <option value="" disabled>Select Sub Category</option>
                      {subCategories.map((sub) => (
                        <option key={sub.id} value={sub.id}>
                          {sub.title}
                        </option>
                      ))}
                    </select>

                    {errors.sub_category_id && <p className="text-sm text-red-500">Product type is required</p>}
                    {errors.category_id && <p className="text-sm text-red-500">Product category is required</p>}
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                    <div>
                      <label className="block font-medium mb-1 text-[14px]">Product Price</label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-3 flex items-center text-gray-500">$</span>
                        <input
                          type="number"
                          {...register("productPrice", { required: true, min: { value: 0.01, message: "Price must be greater than 0" } })}
                          placeholder="0.00"
                          className="w-full pl-7 pr-3 py-2 border rounded-md outline-none focus:ring focus:ring-green-200"
                        />
                      </div>
                      {errors.productPrice && <p className="text-red-500">{errors.productPrice.message}</p>}
                    </div>

                    <div>
                      <label className="block font-medium mb-1 text-[14px]">Discount Price</label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-3 flex items-center text-gray-500">$</span>
                        <input type="number" {...register("discountPrice", {
                          validate: (val) => !val || parseFloat(val) <= parseFloat(watch("productPrice") || 0) || "Discount cannot exceed base price"
                        })} readOnly className="w-full pl-7 pr-3 py-2 border rounded-md outline-none focus:ring focus:ring-green-200 bg-gray-200" />
                      </div>
                      {errors.discountPrice && <p className="text-red-500">{errors.discountPrice.message}</p>}
                    </div>

                    <div>
                      <label className="block font-medium mb-1 text-[14px]">Offer Percentage</label>
                      <input type="number" {...register("offerPercentage")} placeholder="Enter Offer %" className="w-full p-2 border rounded-md outline-none focus:ring focus:ring-green-200" />
                    </div>

                    <div>
                      <label className="block font-medium mb-1 text-[14px]">Product Qty</label>
                      <input type="number" {...register("productQty", { required: true, min: { value: 0, message: "Product Qty cannot be negative" } })} placeholder="Enter No of Qty" className="w-full p-2 border rounded-md outline-none focus:ring focus:ring-green-200" />
                      {errors.productQty && <p className="text-red-500">{errors.productQty.message}</p>}
                    </div>
                  </div>

                  <div>
                    <label className="block font-medium mb-2 text-[14px]">Product Media</label>

                    {/* <input type="file" multiple accept="image/jpeg,image/png,image/webp,video/mp4" onChange={handleMediaChange} className="mb-4 border-2 p-2 rounded-md " /> */}
                    <input type="file" multiple accept="image/jpeg,image/png,image/webp,video/mp4" onChange={handleMediaChange} className="mb-4 border-2 p-2 rounded-md " />
                    <div className="flex gap-2 flex-wrap">
                      {uploadedMedia.map((media, index) => (
                        <div key={media.id || index} className="relative">
                          {media.type === "image" ? (
                            <img src={media.url} className="rounded-lg max-w-[244px] max-h-[244px]" alt="preview" />
                          ) : (
                            <video src={media.url} controls className="rounded-lg max-w-[244px] max-h-[244px]" />
                          )}
                          <div className="absolute bottom-2 left-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded">
                            {media.status} - {media.progress}%
                          </div>
                          <button
                            onClick={() => {
                              setUploadedMedia((prev) => prev.filter((_, i) => i !== index));
                              URL.revokeObjectURL(media.url);
                            }}
                            type="button"
                            className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1"
                          >
                            <FaTimes />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {error && <p className="text-red-500">{error}</p>}

                <div>
                  <button type="submit" disabled={loading} className="px-6 py-2 mt-4 bg-green-800 text-white rounded-full hover:bg-green-900 disabled:opacity-50">
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}
